import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-subnav-wrap"
}
const _hoisted_2 = {
  class: "page-subnav-breadcrumb",
  "aria-label": "Навигационная цепочка"
}
const _hoisted_3 = { class: "page-subnav-breadcrumb__list" }
const _hoisted_4 = { class: "page-subnav-breadcrumb__item" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "page-subnav-breadcrumb__item page-subnav-breadcrumb__item--current",
  "aria-current": "page"
}
const _hoisted_7 = { class: "page-subnav-breadcrumb__current" }
const _hoisted_8 = { class: "page-subnav-breadcrumb__item" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  class: "page-subnav-breadcrumb__item page-subnav-breadcrumb__item--current",
  "aria-current": "page"
}
const _hoisted_11 = { class: "page-subnav-breadcrumb__current" }
const _hoisted_12 = {
  key: 0,
  class: "page-subnav__title"
}
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = { class: "page-subnav__list" }
const _hoisted_15 = ["href"]

import { computed, ref, nextTick, onMounted, watch } from 'vue';
import type { SubnavItem } from './subnav-config';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageSubnav',
  props: {
    items: {},
    activeHref: {},
    sectionTitle: {},
    homeHref: {},
    sectionHref: {},
    simpleBreadcrumb: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const activeLink = ref<HTMLAnchorElement | null>(null);

const currentPageLabel = computed(() => {
  const item = props.items.find((i) => i.href === props.activeHref);
  return item?.label ?? props.sectionTitle;
});

function isActive(item: SubnavItem): boolean {
  if (!props.activeHref) return false;
  return item.href === props.activeHref;
}

function setActiveLink(el: Element | null, item: SubnavItem) {
  if (isActive(item) && el instanceof HTMLAnchorElement) {
    activeLink.value = el;
  }
}

function scrollToActive() {
  nextTick(() => {
    activeLink.value?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  });
}

onMounted(scrollToActive);

watch(() => props.activeHref, scrollToActive);

return (_ctx: any,_cache: any) => {
  return (__props.items.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          _createElementVNode("ol", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("a", {
                href: __props.homeHref,
                class: "page-subnav-breadcrumb__link"
              }, "Главная", 8, _hoisted_5)
            ]),
            (__props.simpleBreadcrumb)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(__props.sectionTitle), 1)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("li", _hoisted_8, [
                    _createElementVNode("a", {
                      href: __props.sectionHref,
                      class: "page-subnav-breadcrumb__link"
                    }, _toDisplayString(__props.sectionTitle), 9, _hoisted_9)
                  ]),
                  _createElementVNode("li", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(currentPageLabel.value), 1)
                  ])
                ], 64))
          ])
        ]),
        (__props.sectionTitle)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(__props.sectionTitle), 1))
          : _createCommentVNode("", true),
        _createElementVNode("nav", {
          class: "page-subnav",
          "aria-label": __props.sectionTitle || 'Дополнительная навигация по разделу'
        }, [
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i,
                class: "page-subnav__item"
              }, [
                _createElementVNode("a", {
                  ref_for: true,
                  ref: el => setActiveLink(el as Element, item),
                  href: item.href,
                  class: _normalizeClass(["page-subnav__link", { 'page-subnav__link--active': isActive(item) }])
                }, _toDisplayString(item.label), 11, _hoisted_15)
              ]))
            }), 128))
          ])
        ], 8, _hoisted_13)
      ]))
    : _createCommentVNode("", true)
}
}

})